import { render } from "./EventList.vue?vue&type=template&id=a66ea9c2&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=a66ea9c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a66ea9c2"

export default script